"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.trim.js");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _regeneratorKeys2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regeneratorKeys.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _typeof2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/typeof.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _index = require("./index");
var _index2 = _interopRequireDefault(require("../../../../components/ActivationCode/index.vue"));
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _hike = require("@/api/hike");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vuex = require("vuex");
var _lhJsEmailContentLib = require("@lifehikes/lh-js-email-content-lib");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "HikeMain",
  components: {
    HikeGeninfo: _index.HikeGeninfo,
    HikeStaff: _index.HikeStaff,
    HikeResource: _index.HikeResource,
    HikeCode: _index.HikeCode,
    HikeStage: _index.HikeStage,
    HikeParticipant: _index.HikeParticipant,
    HikeReport: _index.HikeReport,
    HikeSurvey: _index.HikeSurvey,
    ActivationCode: _index2.default,
    HikeEmailSetting: _index.HikeEmailSetting
  },
  props: {
    displayType: {
      type: String,
      default: "create"
    }
  },
  data: function data() {
    return {
      fullscreenloading: false,
      recordStatus: "",
      flagRemindSave: false,
      hikeForm: {
        id: "",
        category: "",
        skillCompassDimensions: "auto",
        // For new create hike, use new 16+4 skill compass.
        title: "",
        publish: "",
        channel: "vilt",
        rubricId: "",
        pid: "",
        webinarName: "",
        webinarKey: "",
        webinarPasscode: "",
        estimatedParticipantCount: 0,
        start: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        end: {
          utc: "",
          timezone: _momentTimezone.default.tz.guess(),
          local: ""
        },
        // expiry: { utc: '', timezone: moment.tz.guess(), local: '' },   // no use
        address: {
          address1: "",
          address2: "",
          city: "",
          region: "",
          postalCode: "",
          country: ""
        },
        // locale: 'en',  no use
        description: "",
        resources: [],
        stages: [],
        tags: [],
        staff: [],
        isFeedbackEnabled: true,
        isPostProgramFeedbackEnabled: false,
        postProgramFeedbackSurveyLandingPageUrl: null,
        feedbackUrl: "",
        report: {},
        tempInternalTitle: "",
        internal: {
          title: "",
          opportunityNumber: "",
          clientName: "",
          remark: ""
        },
        metadata: {
          tenant: ""
        },
        ratingMethod: "by_assignment",
        emailRuleSet: "",
        automatedEmail: [],
        zoomUrl: "",
        orientationUrl: "",
        trailGuideUrl: "",
        loopScheduleViewUrl: "",
        createdAt: "",
        updatedAt: ""
      },
      oldClientPocList: [],
      relatedLoops: [],
      relatedLoopsLoading: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["email"])),
  created: function created() {
    if (this.displayType === "edit") {
      var id = typeof this.$route.params.id === "undefined" ? this.hikeForm.id : this.$route.params.id;
      this.recordStatus = "edit";
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getHike(id, false); // copy mode is false
    } else if (this.displayType === "createfromcopy") {
      this.fromId = typeof this.$route.query.fromId === "undefined" ? "" : this.$route.query.fromId;
      this.getHike(this.fromId, true);
    } else {
      // create from new
      this.recordStatus = "create";
    }
  },
  watch: {
    'hikeForm.category': function hikeFormCategory(val) {
      if (val === 'manager') {
        if (!this.hikeForm.survey) {
          this.$set(this.hikeForm, 'survey', {
            benchmarkSelfAssessment: '',
            benchmarkBoss: '',
            benchmarkPeer: '',
            benchmarkDirectReport: '',
            summitSelfAssessment: '',
            summitBoss: '',
            summitPeer: '',
            summitDirectReport: '',
            start: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            end: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            summitStart: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            summitEnd: {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            },
            reminderSetting: {
              benchmark: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              },
              summit: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              }
            }
          });
        }
      }
    }
  },
  methods: {
    showReportTab: function showReportTab() {
      if (this.hikeForm.skillCompassDimensions === "auto") {
        return true;
      }
      return false;
    },
    doCreate: function doCreate(publishStatus) {
      var _this = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var token, oEmail, msg, _msg, _msg2, _msg3, startDate, endDate, _msg4, _msg5, stageLength, _msg6, _msg7, ret, stageIndex, _startDate, _endDate, _msg8, actionSetIndex, actionSet, type, raterCount, _raterCount, _msg9, _msg0, _msg1, _msg10, _msg11, _msg12, _msg13, _msg14, _msg15, benchmarkStartDate, benchmarkEndDate, _msg16, _msg17, summitStartDate, summitEndDate, _msg18, i, j, k, resource, resId, data, _t, _t2, _t3, _t4;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.fullscreenloading = true;
              token = (0, _cookie.getCookie)("ACCESS_TOKEN");
              oEmail = (0, _cookie.getCookie)("EMAIL");
              _this.hikeForm.publish = publishStatus;
              _this.hikeForm.internal.title = _this.hikeForm.tempInternalTitle;

              // validate
              if (!(_this.hikeForm.metadata.tenant === "")) {
                _context.n = 1;
                break;
              }
              _this.fullscreenloading = false;
              msg = "Please select the tenant";
              (0, _log.displayPopupMessage)(msg, "error");
              return _context.a(2);
            case 1:
              if (!(_this.hikeForm.category === "")) {
                _context.n = 2;
                break;
              }
              _this.fullscreenloading = false;
              _msg = "Please select the category";
              (0, _log.displayPopupMessage)(_msg, "error");
              return _context.a(2);
            case 2:
              if (!(_this.hikeForm.title === "")) {
                _context.n = 3;
                break;
              }
              _this.fullscreenloading = false;
              _msg2 = "Title is missing";
              (0, _log.displayPopupMessage)(_msg2, "error");
              return _context.a(2);
            case 3:
              if (!(_this.hikeForm.start.utc === "" || _this.hikeForm.end.utc === "")) {
                _context.n = 4;
                break;
              }
              _this.fullscreenloading = false;
              _msg3 = "Hike event time is missing";
              (0, _log.displayPopupMessage)(_msg3, "error");
              return _context.a(2);
            case 4:
              startDate = new Date(_this.hikeForm.start.utc);
              endDate = new Date(_this.hikeForm.end.utc);
              if (!(startDate > endDate)) {
                _context.n = 5;
                break;
              }
              _this.fullscreenloading = false;
              _msg4 = "Start-Time is later than End-Time in Hike event time";
              (0, _log.displayPopupMessage)(_msg4, "error");
              return _context.a(2);
            case 5:
              if (!(_this.hikeForm.start.timezone === "" || _this.hikeForm.end.timezone === "")) {
                _context.n = 6;
                break;
              }
              _this.fullscreenloading = false;
              _msg5 = "Timezone is missing";
              (0, _log.displayPopupMessage)(_msg5, "error");
              return _context.a(2);
            case 6:
              stageLength = typeof _this.hikeForm.stages === "undefined" ? 0 : _this.hikeForm.stages.length;
              if (!(stageLength > 0)) {
                _context.n = 18;
                break;
              }
              if (!(!_this.hikeForm.stages[0].taskSortDay && _this.hikeForm.stages[0].type === "benchmark" && _this.hikeForm.publish !== "draft")) {
                _context.n = 7;
                break;
              }
              _this.fullscreenloading = false;
              _msg6 = "Missing rating deadline setting. Please make sure it has value in benchmark";
              (0, _log.displayPopupMessage)(_msg6, "error");
              return _context.a(2);
            case 7:
              if (!(!_this.hikeForm.stages[stageLength - 1].taskSortDay && _this.hikeForm.stages[stageLength - 1].type === "summit" && _this.hikeForm.publish !== "draft")) {
                _context.n = 8;
                break;
              }
              _this.fullscreenloading = false;
              _msg7 = "Missing rating deadline setting. Please make sure it has value in summit";
              (0, _log.displayPopupMessage)(_msg7, "error");
              return _context.a(2);
            case 8:
              if (_this.hikeForm.stages[0].type === "benchmark" && _this.hikeForm.stages[stageLength - 1].type === "summit") {
                _context.n = 10;
                break;
              }
              _context.n = 9;
              return _this.$confirm("The structure of Hike is incomplete, Continue?", "Warning", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "warning"
              }).then(function () {
                return true;
              }).catch(function () {
                _this.fullscreenloading = false;
                (0, _log.displayPopupMessage)("Please make sure the Hike structure is benchmark + stage(s) + summit", "error");
                return false;
              });
            case 9:
              ret = _context.v;
              if (ret) {
                _context.n = 10;
                break;
              }
              return _context.a(2);
            case 10:
              _t = (0, _regeneratorKeys2.default)(_this.hikeForm.stages);
            case 11:
              if ((_t2 = _t()).done) {
                _context.n = 18;
                break;
              }
              stageIndex = _t2.value;
              if (!((_this.hikeForm.stages[stageIndex].start.utc === "" || _this.hikeForm.stages[stageIndex].end.utc === "") && _this.hikeForm.publish !== "draft")) {
                _context.n = 12;
                break;
              }
              _this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Event time is missing in Stage " + (1 * stageIndex + 1), "error");
              return _context.a(2);
            case 12:
              _startDate = new Date(_this.hikeForm.stages[stageIndex].start.utc);
              _endDate = new Date(_this.hikeForm.stages[stageIndex].end.utc);
              if (!(_startDate > _endDate && _this.hikeForm.publish !== "draft")) {
                _context.n = 13;
                break;
              }
              _this.fullscreenloading = false;
              _msg8 = "Start-Time is later than End-Time in Stage " + (1 * stageIndex + 1) + " event time";
              (0, _log.displayPopupMessage)(_msg8, "error");
              return _context.a(2);
            case 13:
              _t3 = (0, _regeneratorKeys2.default)(_this.hikeForm.stages[stageIndex].actionSets);
            case 14:
              if ((_t4 = _t3()).done) {
                _context.n = 17;
                break;
              }
              actionSetIndex = _t4.value;
              actionSet = _this.hikeForm.stages[stageIndex].actionSets[actionSetIndex];
              type = actionSet.type;
              if (!(type === "benchmark" && _this.hikeForm.publish !== "draft")) {
                _context.n = 15;
                break;
              }
              raterCount = actionSet.raterCount;
              if (!(raterCount === undefined)) {
                _context.n = 15;
                break;
              }
              _this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("RaterCount is missing in Stage " + (1 * stageIndex + 1) + ", Activity " + (1 * actionSetIndex + 1), "error");
              return _context.a(2);
            case 15:
              if (!(type === "summit" && _this.hikeForm.publish !== "draft")) {
                _context.n = 16;
                break;
              }
              _raterCount = actionSet.raterCount;
              if (!(_raterCount === undefined)) {
                _context.n = 16;
                break;
              }
              _this.fullscreenloading = false;
              (0, _log.displayPopupMessage)("RaterCount is missing in Stage " + (1 * stageIndex + 1) + ", Activity " + (1 * actionSetIndex + 2), "error");
              return _context.a(2);
            case 16:
              _context.n = 14;
              break;
            case 17:
              _context.n = 11;
              break;
            case 18:
              if (!(_this.hikeForm.category === 'manager')) {
                _context.n = 30;
                break;
              }
              if (!(_this.hikeForm.survey.benchmarkSelfAssessment || _this.hikeForm.survey.benchmarkBoss || _this.hikeForm.survey.benchmarkPeer || _this.hikeForm.survey.benchmarkDirectReport || _this.hikeForm.survey.summitSelfAssessment || _this.hikeForm.survey.summitBoss || _this.hikeForm.survey.summitPeer || _this.hikeForm.survey.summitDirectReport)) {
                _context.n = 26;
                break;
              }
              if (_this.hikeForm.survey.benchmarkSelfAssessment) {
                _context.n = 19;
                break;
              }
              _this.fullscreenloading = false;
              _msg9 = "Please select Benchmark Self Assessment Survey";
              (0, _log.displayPopupMessage)(_msg9, "error");
              return _context.a(2);
            case 19:
              if (_this.hikeForm.survey.benchmarkBoss) {
                _context.n = 20;
                break;
              }
              _this.fullscreenloading = false;
              _msg0 = "Please select Benchmark Boss Survey";
              (0, _log.displayPopupMessage)(_msg0, "error");
              return _context.a(2);
            case 20:
              if (_this.hikeForm.survey.benchmarkPeer) {
                _context.n = 21;
                break;
              }
              _this.fullscreenloading = false;
              _msg1 = "Please select Benchmark Peer Survey";
              (0, _log.displayPopupMessage)(_msg1, "error");
              return _context.a(2);
            case 21:
              if (_this.hikeForm.survey.benchmarkDirectReport) {
                _context.n = 22;
                break;
              }
              _this.fullscreenloading = false;
              _msg10 = "Please select Benchmark Direct Report Survey";
              (0, _log.displayPopupMessage)(_msg10, "error");
              return _context.a(2);
            case 22:
              if (_this.hikeForm.survey.summitSelfAssessment) {
                _context.n = 23;
                break;
              }
              _this.fullscreenloading = false;
              _msg11 = "Please select Summit Self Assessment Survey";
              (0, _log.displayPopupMessage)(_msg11, "error");
              return _context.a(2);
            case 23:
              if (_this.hikeForm.survey.summitBoss) {
                _context.n = 24;
                break;
              }
              _this.fullscreenloading = false;
              _msg12 = "Please select Summit Boss Survey";
              (0, _log.displayPopupMessage)(_msg12, "error");
              return _context.a(2);
            case 24:
              if (_this.hikeForm.survey.summitPeer) {
                _context.n = 25;
                break;
              }
              _this.fullscreenloading = false;
              _msg13 = "Please select Summit Peer Survey";
              (0, _log.displayPopupMessage)(_msg13, "error");
              return _context.a(2);
            case 25:
              if (_this.hikeForm.survey.summitDirectReport) {
                _context.n = 26;
                break;
              }
              _this.fullscreenloading = false;
              _msg14 = "Please select Summit Direct Report Survey";
              (0, _log.displayPopupMessage)(_msg14, "error");
              return _context.a(2);
            case 26:
              if (!(_this.hikeForm.survey.start.utc === "" || _this.hikeForm.survey.end.utc === "")) {
                _context.n = 27;
                break;
              }
              _this.fullscreenloading = false;
              _msg15 = "Benchmark effective date is missing";
              (0, _log.displayPopupMessage)(_msg15, "error");
              return _context.a(2);
            case 27:
              benchmarkStartDate = new Date(_this.hikeForm.survey.start.utc);
              benchmarkEndDate = new Date(_this.hikeForm.survey.end.utc);
              if (!(benchmarkStartDate > benchmarkEndDate)) {
                _context.n = 28;
                break;
              }
              _this.fullscreenloading = false;
              _msg16 = "Start-Time is later than End-Time in Benchmark effective date";
              (0, _log.displayPopupMessage)(_msg16, "error");
              return _context.a(2);
            case 28:
              if (!(_this.hikeForm.survey.summitStart.utc === "" || _this.hikeForm.survey.summitEnd.utc === "")) {
                _context.n = 29;
                break;
              }
              _this.fullscreenloading = false;
              _msg17 = "Summit effective date is missing";
              (0, _log.displayPopupMessage)(_msg17, "error");
              return _context.a(2);
            case 29:
              summitStartDate = new Date(_this.hikeForm.survey.summitStart.utc);
              summitEndDate = new Date(_this.hikeForm.survey.summitEnd.utc);
              if (!(summitStartDate > summitEndDate)) {
                _context.n = 30;
                break;
              }
              _this.fullscreenloading = false;
              _msg18 = "Start-Time is later than End-Time in Summit effective date";
              (0, _log.displayPopupMessage)(_msg18, "error");
              return _context.a(2);
            case 30:
              //fixed bug LHVO4121
              //Admin Portal - Hike - The resources ID will auto-disappear after copying and saving the Hike
              // remove stage resource is empty value
              for (i = 0; i < _this.checkArrayLength(_this.hikeForm.stages); i++) {
                if (_this.hikeForm.stages[i].replayResource === "" || _this.hikeForm.stages[i].replayResource === null) {
                  _this.hikeForm.stages[i].replayResource = undefined;
                }
                for (j = 0; j < _this.checkArrayLength(_this.hikeForm.stages[i].actionSets); j++) {
                  for (k = 0; k < _this.checkArrayLength(_this.hikeForm.stages[i].actionSets[j].actions); k++) {
                    if (_this.hikeForm.stages[i].actionSets[j].actions[k].type === "resource") {
                      resource = _this.hikeForm.stages[i].actionSets[j].actions[k].resource;
                      if ((0, _typeof2.default)(resource) === "object") {
                        resId = resource ? resource.id : null;
                        console.info("submit before Resource object:");
                        console.info("stage" + i + " actionSets" + j + " actions" + k + " resID=" + resId);
                        console.info(resource);
                        _this.hikeForm.stages[i].actionSets[j].actions[k].resource = resId;
                        console.info("submit after Resource object:");
                        console.info(_this.hikeForm.stages[i].actionSets[j].actions[k].resource);
                        console.info("---------------------------------");
                      } else {
                        resId = resource ? resource : null;
                        console.info("submit before Resource string:");
                        console.info("stage" + i + " actionSets" + j + " actions" + k + " resID=" + resId);
                        console.info(resource);
                        _this.hikeForm.stages[i].actionSets[j].actions[k].resource = resId;
                        console.info("submit after Resource string:");
                        console.info(_this.hikeForm.stages[i].actionSets[j].actions[k].resource);
                        console.info("---------------------------------");
                      }
                    }
                  }
                }
              }

              // Reset Id to '' if copy
              if (_this.hikeForm.id === "copy") {
                _this.hikeForm.id = "";
              }

              // submit
              if (_this.hikeForm.id === "") {
                // If category is not 'manager', do not send 'survey' data
                if (_this.hikeForm.category !== 'manager') {
                  delete _this.hikeForm.survey;
                }
                // console.info('submit hikeForm:')
                // console.info(JSON.stringify(this.hikeForm))
                data = _lodash.default.cloneDeep(_this.hikeForm);
                data.isFeedbackEnabled = _this.hikeForm.isFeedbackEnabled;
                data.isPostProgramFeedbackEnabled = _this.hikeForm.isPostProgramFeedbackEnabled;
                delete data.createdAt;
                delete data.updatedAt;
                (0, _hike.createHike)(token, data).then(function (response) {
                  (0, _log.showDebugLog)("Hike-create-response1", response);
                  _this.fullscreenloading = false;
                  _this.hikeForm.id = response.data.id;
                  _this.hikeForm.publish = response.data.publish;

                  // console.log('Success create', this.displayType)
                  var msg = "".concat(response.data.title, " (").concat(response.data.id, ") is created.");
                  var coachTools = _this.$store.getters.coachTools;
                  var availableRateJobDays = coachTools.availableRateJobDays;
                  console.info('coachTools');
                  console.info(availableRateJobDays);
                  var localDate = (0, _momentTimezone.default)().subtract(availableRateJobDays, 'd');
                  var localUTCDate = _momentTimezone.default.parseZone(localDate).utc();
                  console.info(localDate.format());
                  console.info(localUTCDate.format());
                  console.info('start.utc');
                  console.info(_this.hikeForm.start.utc);
                  if (localUTCDate.isAfter(_this.hikeForm.start.utc)) {
                    //console.info('开始日期小于本utc时间')
                    msg = "This Hike started over ".concat(availableRateJobDays, " days ago. Certain functions will not work, including Benchmark/Summit ratings.");
                    (0, _log.displayPopupMessage)(msg, "warning", 0);
                  } else {
                    //console.info('开始日期大于本utc时间')
                    (0, _log.displayPopupMessage)(msg, "success");
                  }
                  if (_this.hikeForm.category === 'manager') {
                    _this.$refs.hikeSurvey.resetSurveyFormChangedStatus();
                  }
                  _this.hikeForm.isFeedbackEnabled = response.data.isFeedbackEnabled;
                  _this.hikeForm.isPostProgramFeedbackEnabled = response.data.isPostProgramFeedbackEnabled;
                  _this.hikeForm.postProgramFeedbackSurveyLandingPageUrl = response.data.postProgramFeedbackSurveyLandingPageUrl;
                  // this.isCreatedRecord = true

                  (0, _ga.writeGaEvent)(_this, "Hike", "".concat(_lifehikesInitData.userEvent.hike.create), oEmail, "Hike Id: ".concat(_this.hikeForm.id));
                  var keys_to_keep = ["role", "user"];
                  var result = _this.hikeForm.staff.map(function (e) {
                    var obj = {};
                    keys_to_keep.forEach(function (k) {
                      return obj[k] = e[k];
                    });
                    return obj;
                  });
                  (0, _ga.writeGaEvent)(_this, "Hike", "".concat(_lifehikesInitData.userEvent.hike.create), oEmail, "Staff: ".concat(JSON.stringify(result)));
                  if (_this.displayType === "createfromcopy" || _this.displayType === "create") {
                    _this.$router.push("/hike/edit/".concat(response.data.id));
                  }
                }).catch(function (error) {
                  (0, _log.showDebugLog)("hike-create-error", error);
                  _this.fullscreenloading = false;
                  (0, _log.displayPopupMessage)(error, "error");
                });
              }
            case 31:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    doSave: function doSave(publishStatus) {
      var _this2 = this;
      return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var token, oEmail, id, msg, _msg19, _msg20, _msg21, _msg22, _msg23, _msg24, startDate, endDate, _msg25, _msg26, stageLength, benchmarkCount, summitCount, _msg27, _msg28, _msg29, _msg30, _msg31, _msg32, ret, stageActionSetTypes, sidx, _iterator, _step, stage, actionSetTypes, _iterator2, _step2, actionSet, _msg34, stageIndex, _startDate2, _endDate2, _msg33, errMsg, scoreConfig, skillGroup, _iterator3, _step3, tmp, _iterator4, _step4, _tmp, _iterator5, _step5, _tmp2, _iterator6, _step6, skill, i, _stageIndex, actionSetIdnex, type, enable720Survey, actionIndex, skillId, resource, _id, _msg35, _msg36, _msg37, _msg38, _msg39, _msg40, _msg41, _msg42, _msg43, benchmarkStartDate, benchmarkEndDate, _msg44, _msg45, summitStartDate, summitEndDate, _msg46, _t5, _t6, _t7, _t8, _t9, _t0, _t1, _t10, _t11, _t12, _t13, _t14, _t15, _t16;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _this2.fullscreenloading = true;
              token = (0, _cookie.getCookie)("ACCESS_TOKEN");
              oEmail = (0, _cookie.getCookie)("EMAIL");
              id = typeof _this2.$route.params.id === "undefined" ? _this2.hikeForm.id : _this2.$route.params.id;
              _this2.hikeForm.publish = publishStatus;
              _this2.hikeForm.internal.title = _this2.hikeForm.tempInternalTitle + "";

              // validate
              if (!(_this2.hikeForm.metadata.tenant === "")) {
                _context2.n = 1;
                break;
              }
              _this2.fullscreenloading = false;
              msg = "Please select the tenant";
              (0, _log.displayPopupMessage)(msg, "error");
              return _context2.a(2);
            case 1:
              if (!(_this2.hikeForm.category === "")) {
                _context2.n = 2;
                break;
              }
              _this2.fullscreenloading = false;
              _msg19 = "Please select the category";
              (0, _log.displayPopupMessage)(_msg19, "error");
              return _context2.a(2);
            case 2:
              if (!(_this2.hikeForm.orientationUrl !== '' && !/^https?:\/\//i.test(_this2.hikeForm.orientationUrl))) {
                _context2.n = 3;
                break;
              }
              _this2.fullscreenloading = false;
              _msg20 = "Please input valid URL format in Session Zero Link.";
              (0, _log.displayPopupMessage)(_msg20, "error");
              return _context2.a(2);
            case 3:
              if (!(_this2.hikeForm.trailGuideUrl !== '' && !/^https?:\/\//i.test(_this2.hikeForm.trailGuideUrl))) {
                _context2.n = 4;
                break;
              }
              _this2.fullscreenloading = false;
              _msg21 = "Please input valid URL format in Trail Guide Link.";
              (0, _log.displayPopupMessage)(_msg21, "error");
              return _context2.a(2);
            case 4:
              if (!(_this2.hikeForm.loopScheduleViewUrl !== '' && !/^https?:\/\//i.test(_this2.hikeForm.loopScheduleViewUrl))) {
                _context2.n = 5;
                break;
              }
              _this2.fullscreenloading = false;
              _msg22 = "Please input valid URL format in Loop Schedule View Link.";
              (0, _log.displayPopupMessage)(_msg22, "error");
              return _context2.a(2);
            case 5:
              if (!(_this2.hikeForm.zoomUrl !== '' && !/^https?:\/\//i.test(_this2.hikeForm.zoomUrl))) {
                _context2.n = 6;
                break;
              }
              _this2.fullscreenloading = false;
              _msg23 = "Please input valid URL format in Zoom Invite Link.";
              (0, _log.displayPopupMessage)(_msg23, "error");
              return _context2.a(2);
            case 6:
              if (!(_this2.hikeForm.start.utc === "" || _this2.hikeForm.end.utc === "")) {
                _context2.n = 7;
                break;
              }
              _this2.fullscreenloading = false;
              _msg24 = "Hike event time is missing";
              (0, _log.displayPopupMessage)(_msg24, "error");
              return _context2.a(2);
            case 7:
              startDate = new Date(_this2.hikeForm.start.utc);
              endDate = new Date(_this2.hikeForm.end.utc);
              if (!(startDate > endDate)) {
                _context2.n = 8;
                break;
              }
              _this2.fullscreenloading = false;
              _msg25 = "Start-Time is later than End-Time in Hike event time";
              (0, _log.displayPopupMessage)(_msg25, "error");
              return _context2.a(2);
            case 8:
              if (!(_this2.hikeForm.title === "")) {
                _context2.n = 9;
                break;
              }
              _this2.fullscreenloading = false;
              _msg26 = "Hike's title is missing";
              (0, _log.displayPopupMessage)(_msg26, "error");
              return _context2.a(2);
            case 9:
              //if (this.hikeForm.publish !== "draft") {
              // if (this.hikeForm.category === "") {
              //   this.fullscreenloading = false;
              //   const msg = `Hike's category is missing`;
              //   displayPopupMessage(msg, "error");
              //   return;
              // }
              // check first stage must be benchmark and last stage must be submit
              stageLength = typeof _this2.hikeForm.stages === "undefined" ? 0 : _this2.hikeForm.stages.length;
              if (!(stageLength > 0)) {
                _context2.n = 34;
                break;
              }
              benchmarkCount = _this2.hikeForm.stages.filter(function (element) {
                return element.type === "benchmark";
              }).length;
              summitCount = _this2.hikeForm.stages.filter(function (element) {
                return element.type === "summit";
              }).length;
              if (!(benchmarkCount > 1)) {
                _context2.n = 10;
                break;
              }
              _this2.fullscreenloading = false;
              _msg27 = "Stage setting has something wrong. Please make sure only one stage is Benchmark.";
              (0, _log.displayPopupMessage)(_msg27, "error");
              return _context2.a(2);
            case 10:
              if (!(summitCount > 1)) {
                _context2.n = 11;
                break;
              }
              _this2.fullscreenloading = false;
              _msg28 = "Stage setting has something wrong. Please make sure only one stage is Summit.";
              (0, _log.displayPopupMessage)(_msg28, "error");
              return _context2.a(2);
            case 11:
              if (!(benchmarkCount == 1 && stageLength > 1 && _this2.hikeForm.stages[0].type !== "benchmark")) {
                _context2.n = 12;
                break;
              }
              _this2.fullscreenloading = false;
              _msg29 = "Stage setting has something wrong. Please make sure the first stage is Benchmark";
              (0, _log.displayPopupMessage)(_msg29, "error");
              return _context2.a(2);
            case 12:
              if (!(summitCount == 1 && stageLength > 1 && _this2.hikeForm.stages[stageLength - 1].type !== "summit")) {
                _context2.n = 13;
                break;
              }
              _this2.fullscreenloading = false;
              _msg30 = "Stage setting has something wrong. Please make sure the last stage is Summit.";
              (0, _log.displayPopupMessage)(_msg30, "error");
              return _context2.a(2);
            case 13:
              if (!(!_this2.hikeForm.stages[0].taskSortDay && _this2.hikeForm.stages[0].type === "benchmark" && _this2.hikeForm.publish !== "draft")) {
                _context2.n = 14;
                break;
              }
              _this2.fullscreenloading = false;
              _msg31 = "Missing rating deadline setting. Please make sure it has value in benchmark";
              (0, _log.displayPopupMessage)(_msg31, "error");
              return _context2.a(2);
            case 14:
              if (!(!_this2.hikeForm.stages[stageLength - 1].taskSortDay && _this2.hikeForm.stages[stageLength - 1].type === "summit" && _this2.hikeForm.publish !== "draft")) {
                _context2.n = 15;
                break;
              }
              _this2.fullscreenloading = false;
              _msg32 = "Missing rating deadline setting. Please make sure it has value in summit";
              (0, _log.displayPopupMessage)(_msg32, "error");
              return _context2.a(2);
            case 15:
              if (_this2.hikeForm.stages[0].type === "benchmark" && _this2.hikeForm.stages[stageLength - 1].type === "summit") {
                _context2.n = 17;
                break;
              }
              _context2.n = 16;
              return _this2.$confirm("The structure of Hike is incomplete, Continue?", "Warning", {
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                type: "warning"
              }).then(function () {
                return true;
              }).catch(function () {
                _this2.fullscreenloading = false;
                (0, _log.displayPopupMessage)("Please make sure the Hike structure is benchmark + stage(s) + summit", "error");
                return false;
              });
            case 16:
              ret = _context2.v;
              if (ret) {
                _context2.n = 17;
                break;
              }
              return _context2.a(2);
            case 17:
              // also make sure the stages have correct actionSets
              stageActionSetTypes = {};
              stageActionSetTypes["stage"] = ["bunny", "diamond", "info", "moment", "bonus"];
              stageActionSetTypes["benchmark"] = ["bunny", "diamond", "moment", "benchmark", "benchmarkreport", "bonus"];
              stageActionSetTypes["summit"] = ["summit", "moment", "summitreport"];
              sidx = 0;
              _iterator = (0, _createForOfIteratorHelper2.default)(_this2.hikeForm.stages);
              _context2.p = 18;
              _iterator.s();
            case 19:
              if ((_step = _iterator.n()).done) {
                _context2.n = 27;
                break;
              }
              stage = _step.value;
              sidx++;
              // Check actionSet
              actionSetTypes = stageActionSetTypes[stage.type];
              _iterator2 = (0, _createForOfIteratorHelper2.default)(stage.actionSets);
              _context2.p = 20;
              _iterator2.s();
            case 21:
              if ((_step2 = _iterator2.n()).done) {
                _context2.n = 23;
                break;
              }
              actionSet = _step2.value;
              if (actionSetTypes.includes(actionSet.type)) {
                _context2.n = 22;
                break;
              }
              _this2.fullscreenloading = false;
              _msg34 = "Stage " + sidx + ":[" + stage.type + "] should not include activity: [" + actionSet.type + ']. Please go to "Stage" -> "Activity Setting page" to update the settings';
              (0, _log.displayPopupMessage)(_msg34, "error");
              return _context2.a(2);
            case 22:
              _context2.n = 21;
              break;
            case 23:
              _context2.n = 25;
              break;
            case 24:
              _context2.p = 24;
              _t5 = _context2.v;
              _iterator2.e(_t5);
            case 25:
              _context2.p = 25;
              _iterator2.f();
              return _context2.f(25);
            case 26:
              _context2.n = 19;
              break;
            case 27:
              _context2.n = 29;
              break;
            case 28:
              _context2.p = 28;
              _t6 = _context2.v;
              _iterator.e(_t6);
            case 29:
              _context2.p = 29;
              _iterator.f();
              return _context2.f(29);
            case 30:
              _t7 = (0, _regeneratorKeys2.default)(_this2.hikeForm.stages);
            case 31:
              if ((_t8 = _t7()).done) {
                _context2.n = 34;
                break;
              }
              stageIndex = _t8.value;
              if (!((_this2.hikeForm.stages[stageIndex].start.utc === "" || _this2.hikeForm.stages[stageIndex].end.utc === "") && _this2.hikeForm.publish !== "draft")) {
                _context2.n = 32;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Event time is missing in Stage " + (1 * stageIndex + 1), "error");
              return _context2.a(2);
            case 32:
              _startDate2 = new Date(_this2.hikeForm.stages[stageIndex].start.utc);
              _endDate2 = new Date(_this2.hikeForm.stages[stageIndex].end.utc);
              if (!(_startDate2 > _endDate2 && _this2.hikeForm.publish !== "draft")) {
                _context2.n = 33;
                break;
              }
              _this2.fullscreenloading = false;
              _msg33 = "Start-Time is later than End-Time in Stage " + (1 * stageIndex + 1) + " event time";
              (0, _log.displayPopupMessage)(_msg33, "error");
              return _context2.a(2);
            case 33:
              _context2.n = 31;
              break;
            case 34:
              if (!_this2.hikeForm.report) {
                _context2.n = 63;
                break;
              }
              errMsg = false;
              scoreConfig = _this2.hikeForm.report.scoreConfig;
              skillGroup = _this2.hikeForm.report.skillGroup;
              if (!scoreConfig) {
                _context2.n = 48;
                break;
              }
              if (!scoreConfig.overall) {
                _context2.n = 41;
                break;
              }
              _iterator3 = (0, _createForOfIteratorHelper2.default)(scoreConfig.overall);
              _context2.p = 35;
              _iterator3.s();
            case 36:
              if ((_step3 = _iterator3.n()).done) {
                _context2.n = 38;
                break;
              }
              tmp = _step3.value;
              if (!(tmp["title"] === "" || tmp["title"] === undefined || tmp["weight"] === undefined)) {
                _context2.n = 37;
                break;
              }
              errMsg = true;
              return _context2.a(3, 38);
            case 37:
              _context2.n = 36;
              break;
            case 38:
              _context2.n = 40;
              break;
            case 39:
              _context2.p = 39;
              _t9 = _context2.v;
              _iterator3.e(_t9);
            case 40:
              _context2.p = 40;
              _iterator3.f();
              return _context2.f(40);
            case 41:
              if (!scoreConfig.video) {
                _context2.n = 48;
                break;
              }
              _iterator4 = (0, _createForOfIteratorHelper2.default)(scoreConfig.video);
              _context2.p = 42;
              _iterator4.s();
            case 43:
              if ((_step4 = _iterator4.n()).done) {
                _context2.n = 45;
                break;
              }
              _tmp = _step4.value;
              if (!(_tmp["title"] === "" || _tmp["title"] === undefined)) {
                _context2.n = 44;
                break;
              }
              errMsg = true;
              return _context2.a(3, 45);
            case 44:
              _context2.n = 43;
              break;
            case 45:
              _context2.n = 47;
              break;
            case 46:
              _context2.p = 46;
              _t0 = _context2.v;
              _iterator4.e(_t0);
            case 47:
              _context2.p = 47;
              _iterator4.f();
              return _context2.f(47);
            case 48:
              if (!skillGroup) {
                _context2.n = 62;
                break;
              }
              if (!skillGroup.groups) {
                _context2.n = 62;
                break;
              }
              _iterator5 = (0, _createForOfIteratorHelper2.default)(skillGroup.groups);
              _context2.p = 49;
              _iterator5.s();
            case 50:
              if ((_step5 = _iterator5.n()).done) {
                _context2.n = 59;
                break;
              }
              _tmp2 = _step5.value;
              if (!(_tmp2["title"] === "" || _tmp2["title"] === undefined)) {
                _context2.n = 51;
                break;
              }
              errMsg = true;
              return _context2.a(3, 59);
            case 51:
              _iterator6 = (0, _createForOfIteratorHelper2.default)(_tmp2.skills);
              _context2.p = 52;
              _iterator6.s();
            case 53:
              if ((_step6 = _iterator6.n()).done) {
                _context2.n = 55;
                break;
              }
              skill = _step6.value;
              if (!(skill["title"] === "" || skill["avgScore"] === undefined)) {
                _context2.n = 54;
                break;
              }
              errMsg = true;
              return _context2.a(3, 55);
            case 54:
              _context2.n = 53;
              break;
            case 55:
              _context2.n = 57;
              break;
            case 56:
              _context2.p = 56;
              _t1 = _context2.v;
              _iterator6.e(_t1);
            case 57:
              _context2.p = 57;
              _iterator6.f();
              return _context2.f(57);
            case 58:
              _context2.n = 50;
              break;
            case 59:
              _context2.n = 61;
              break;
            case 60:
              _context2.p = 60;
              _t10 = _context2.v;
              _iterator5.e(_t10);
            case 61:
              _context2.p = 61;
              _iterator5.f();
              return _context2.f(61);
            case 62:
              if (_this2.hikeForm.report.mostActiveHikersMaxCount === undefined) {
                errMsg = true;
              }
              if (_this2.hikeForm.report.mostActiveHikersMaxCount === undefined) {
                errMsg = true;
              }
              if (!errMsg) {
                _context2.n = 63;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)('Please check "Report" section', "error");
              return _context2.a(2);
            case 63:
              // remove stage resource is empty value
              for (i = 0; i < _this2.hikeForm.stages.length; i++) {
                if (_this2.hikeForm.stages[i].replayResource === "" || _this2.hikeForm.stages[i].replayResource === null) {
                  _this2.hikeForm.stages[i].replayResource = undefined;
                }
              }
              _t11 = (0, _regeneratorKeys2.default)(_this2.hikeForm.stages);
            case 64:
              if ((_t12 = _t11()).done) {
                _context2.n = 73;
                break;
              }
              _stageIndex = _t12.value;
              _t13 = (0, _regeneratorKeys2.default)(_this2.hikeForm.stages[_stageIndex].actionSets);
            case 65:
              if ((_t14 = _t13()).done) {
                _context2.n = 72;
                break;
              }
              actionSetIdnex = _t14.value;
              if (!_this2.hikeForm.report) {
                _context2.n = 66;
                break;
              }
              if (!(_this2.hikeForm.report.show720SurveyData === true)) {
                _context2.n = 66;
                break;
              }
              console.info('stage' + _stageIndex + '的enable720Survey：' + _this2.hikeForm.stages[_stageIndex].enable720Survey);
              type = _this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].type;
              enable720Survey = _this2.hikeForm.stages[_stageIndex].enable720Survey;
              console.info('stage' + _stageIndex + '的enable720Survey：' + enable720Survey);
              console.info('actionSets' + actionSetIdnex + '的type：' + type);
              console.info(enable720Survey !== true && (type === 'benchmark' || type == 'summit'));
              if (!(enable720Survey !== true && (type === 'benchmark' || type == 'summit'))) {
                _context2.n = 66;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("You cannot show 720 Team Survey Data in report because the “Enable 720 Survey” is disabled in benchmark and / or summit activity. Please check it.", "error");
              return _context2.a(2);
            case 66:
              _t15 = (0, _regeneratorKeys2.default)(_this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].actions);
            case 67:
              if ((_t16 = _t15()).done) {
                _context2.n = 71;
                break;
              }
              actionIndex = _t16.value;
              if (!(_this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].actions[actionIndex].type === "skill")) {
                _context2.n = 68;
                break;
              }
              skillId = _this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].actions[actionIndex].skill;
              if (!(skillId === undefined || skillId === null || skillId === "")) {
                _context2.n = 68;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Skill Id is missing in Stage " + (1 * _stageIndex + 1) + " Activity " + (1 * actionSetIdnex + 1) + " Component " + (1 * actionIndex + 1) + ". \nPlease add it before saving activity.", "error");
              return _context2.a(2);
            case 68:
              if (!(_this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].actions[actionIndex].type === "resource")) {
                _context2.n = 70;
                break;
              }
              resource = _this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource;
              if (!(resource === undefined || resource === null)) {
                _context2.n = 69;
                break;
              }
              _this2.fullscreenloading = false;
              (0, _log.displayPopupMessage)("Resource Id is missing in Stage " + (1 * _stageIndex + 1) + " Activity " + (1 * actionSetIdnex + 1) + " Component " + (1 * actionIndex + 1) + ". \nPlease add it before saving activity.", "error");
              return _context2.a(2);
            case 69:
              _id = resource.id;
              if (_id === undefined || resource === null) {
                _this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource = resource;
              } else {
                _this2.hikeForm.stages[_stageIndex].actionSets[actionSetIdnex].actions[actionIndex].resource = resource.id;
              }
            case 70:
              _context2.n = 67;
              break;
            case 71:
              _context2.n = 65;
              break;
            case 72:
              _context2.n = 64;
              break;
            case 73:
              if (!(_this2.hikeForm.category === 'manager')) {
                _context2.n = 85;
                break;
              }
              if (!(_this2.hikeForm.survey.benchmarkSelfAssessment || _this2.hikeForm.survey.benchmarkBoss || _this2.hikeForm.survey.benchmarkPeer || _this2.hikeForm.survey.benchmarkDirectReport || _this2.hikeForm.survey.summitSelfAssessment || _this2.hikeForm.survey.summitBoss || _this2.hikeForm.survey.summitPeer || _this2.hikeForm.survey.summitDirectReport)) {
                _context2.n = 81;
                break;
              }
              if (_this2.hikeForm.survey.benchmarkSelfAssessment) {
                _context2.n = 74;
                break;
              }
              _this2.fullscreenloading = false;
              _msg35 = "Please select Benchmark Self Assessment Survey";
              (0, _log.displayPopupMessage)(_msg35, "error");
              return _context2.a(2);
            case 74:
              if (_this2.hikeForm.survey.benchmarkBoss) {
                _context2.n = 75;
                break;
              }
              _this2.fullscreenloading = false;
              _msg36 = "Please select Benchmark Boss Survey";
              (0, _log.displayPopupMessage)(_msg36, "error");
              return _context2.a(2);
            case 75:
              if (_this2.hikeForm.survey.benchmarkPeer) {
                _context2.n = 76;
                break;
              }
              _this2.fullscreenloading = false;
              _msg37 = "Please select Benchmark Peer Survey";
              (0, _log.displayPopupMessage)(_msg37, "error");
              return _context2.a(2);
            case 76:
              if (_this2.hikeForm.survey.benchmarkDirectReport) {
                _context2.n = 77;
                break;
              }
              _this2.fullscreenloading = false;
              _msg38 = "Please select Benchmark Direct Report Survey";
              (0, _log.displayPopupMessage)(_msg38, "error");
              return _context2.a(2);
            case 77:
              if (_this2.hikeForm.survey.summitSelfAssessment) {
                _context2.n = 78;
                break;
              }
              _this2.fullscreenloading = false;
              _msg39 = "Please select Summit Self Assessment Survey";
              (0, _log.displayPopupMessage)(_msg39, "error");
              return _context2.a(2);
            case 78:
              if (_this2.hikeForm.survey.summitBoss) {
                _context2.n = 79;
                break;
              }
              _this2.fullscreenloading = false;
              _msg40 = "Please select Summit Boss Survey";
              (0, _log.displayPopupMessage)(_msg40, "error");
              return _context2.a(2);
            case 79:
              if (_this2.hikeForm.survey.summitPeer) {
                _context2.n = 80;
                break;
              }
              _this2.fullscreenloading = false;
              _msg41 = "Please select Summit Peer Survey";
              (0, _log.displayPopupMessage)(_msg41, "error");
              return _context2.a(2);
            case 80:
              if (_this2.hikeForm.survey.summitDirectReport) {
                _context2.n = 81;
                break;
              }
              _this2.fullscreenloading = false;
              _msg42 = "Please select Summit Direct Report Survey";
              (0, _log.displayPopupMessage)(_msg42, "error");
              return _context2.a(2);
            case 81:
              if (!(_this2.hikeForm.survey.start.utc === "" || _this2.hikeForm.survey.end.utc === "")) {
                _context2.n = 82;
                break;
              }
              _this2.fullscreenloading = false;
              _msg43 = "Benchmark effective date is missing";
              (0, _log.displayPopupMessage)(_msg43, "error");
              return _context2.a(2);
            case 82:
              benchmarkStartDate = new Date(_this2.hikeForm.survey.start.utc);
              benchmarkEndDate = new Date(_this2.hikeForm.survey.end.utc);
              if (!(benchmarkStartDate > benchmarkEndDate)) {
                _context2.n = 83;
                break;
              }
              _this2.fullscreenloading = false;
              _msg44 = "Start-Time is later than End-Time in Benchmark effective date";
              (0, _log.displayPopupMessage)(_msg44, "error");
              return _context2.a(2);
            case 83:
              if (!(_this2.hikeForm.survey.summitStart.utc === "" || _this2.hikeForm.survey.summitEnd.utc === "")) {
                _context2.n = 84;
                break;
              }
              _this2.fullscreenloading = false;
              _msg45 = "Summit effective date is missing";
              (0, _log.displayPopupMessage)(_msg45, "error");
              return _context2.a(2);
            case 84:
              summitStartDate = new Date(_this2.hikeForm.survey.summitStart.utc);
              summitEndDate = new Date(_this2.hikeForm.survey.summitEnd.utc);
              if (!(summitStartDate > summitEndDate)) {
                _context2.n = 85;
                break;
              }
              _this2.fullscreenloading = false;
              _msg46 = "Start-Time is later than End-Time in Summit effective date";
              (0, _log.displayPopupMessage)(_msg46, "error");
              return _context2.a(2);
            case 85:
              // If category is not 'manager', do not send 'survey' data
              if (_this2.hikeForm.category !== 'manager') {
                delete _this2.hikeForm.survey;
              }

              // if (this.hikeForm.report)
              // {
              //   if (this.hikeForm.report.show720SurveyData === true) {
              //     this.hikeForm.stages.forEach(stage => {
              //       stage.actionSets.forEach(action =>action.type.includes('benchmark','summit'))
              //     })
              //   }
              // }
              // submit
              (0, _log.showDebugLog)("Save Form", _this2.hikeForm);
              (0, _hike.updateHikeById)(token, id, _this2.hikeForm).then(function (response) {
                (0, _log.showDebugLog)("Hike-update-response", response);
                _this2.fullscreenloading = false;
                _this2.hikeForm.id = response.data.id;
                _this2.hikeForm.publish = response.data.publish;
                _this2.hikeForm.staff = response.data.staff;
                _this2.hikeForm.updatedAt = response.data.updatedAt;
                _this2.hikeForm.isFeedbackEnabled = response.data.isFeedbackEnabled;
                _this2.hikeForm.isPostProgramFeedbackEnabled = response.data.isPostProgramFeedbackEnabled;
                _this2.hikeForm.postProgramFeedbackSurveyLandingPageUrl = response.data.postProgramFeedbackSurveyLandingPageUrl;
                var clientPocList = _this2.hikeForm.staff.filter(function (row) {
                  return row.role === 'client-poc';
                });
                _this2.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
                var msg = "".concat(response.data.title, " (").concat(response.data.id, ") is updated.");
                var coachTools = _this2.$store.getters.coachTools;
                var availableRateJobDays = coachTools.availableRateJobDays;
                console.info('coachTools');
                console.info(availableRateJobDays);
                var localDate = (0, _momentTimezone.default)().subtract(availableRateJobDays, 'd');
                var localUTCDate = _momentTimezone.default.parseZone(localDate).utc();
                console.info(localDate.format());
                console.info(localUTCDate.format());
                console.info('start.utc');
                console.info(_this2.hikeForm.start.utc);
                if (localUTCDate.isAfter(_this2.hikeForm.start.utc)) {
                  //console.info('开始日期小于本utc时间')
                  msg = "This Hike started over ".concat(availableRateJobDays, " days ago. Certain functions will not work, including Benchmark/Summit ratings.");
                  (0, _log.displayPopupMessage)(msg, "warning", 0);
                } else {
                  //console.info('开始日期大于本utc时间')
                  (0, _log.displayPopupMessage)(msg, "success");
                }
                if (_this2.$refs.hikeStaff) {
                  _this2.$refs.hikeStaff.getStaffList();
                }
                if (_this2.hikeForm.category === 'manager') {
                  _this2.$refs.hikeSurvey.resetSurveyFormChangedStatus();
                }
                (0, _ga.writeGaEvent)(_this2, "Hike", "".concat(_lifehikesInitData.userEvent.hike.edit), oEmail, "Edit in Hike Main - Hike Id: ".concat(_this2.hikeForm.id));
                (0, _ga.writeGaEvent)(_this2, "Hike", "".concat(_lifehikesInitData.userEvent.hike.edit), _this2.email, "avoid undefined email, Edit in Hike Main - Hike Id: ".concat(_this2.hikeForm.id));
                var keys_to_keep = ["role", "user"];
                var result = _this2.hikeForm.staff.map(function (e) {
                  var obj = {};
                  keys_to_keep.forEach(function (k) {
                    return obj[k] = e[k];
                  });
                  return obj;
                });
                (0, _ga.writeGaEvent)(_this2, "Hike", "".concat(_lifehikesInitData.userEvent.hike.edit), oEmail, "Staff: ".concat(JSON.stringify(result)));
              }).catch(function (error) {
                (0, _log.showDebugLog)("Hike-update-error", error);
                _this2.fullscreenloading = false;
                (0, _log.displayPopupMessage)(error, "error");
              });

              // this.flagRemindSave = (this.hikeForm.stages[0].taskSortDay)? false : true
            case 86:
              return _context2.a(2);
          }
        }, _callee2, null, [[52, 56, 57, 58], [49, 60, 61, 62], [42, 46, 47, 48], [35, 39, 40, 41], [20, 24, 25, 26], [18, 28, 29, 30]]);
      }))();
    },
    getHike: function getHike(id, isCopy) {
      var _this3 = this;
      var token = (0, _cookie.getCookie)("ACCESS_TOKEN");
      this.fullscreenloading = true;
      (0, _hike.getHikeById)(token, id).then(function (response) {
        var d = response.data;
        // check error and return immediate
        if (typeof d.id === "undefined") {
          _this3.fullscreenloading = false;
          var msg = "Cannot get the hike, please contact to system administrator";
          (0, _log.displayPopupMessage)(msg, "error");
          return;
        }
        (0, _log.showDebugLog)("Hike-getHikeById-response", d);
        _this3.hikeForm.id = isCopy ? "copy" : d.id;

        // In-app feedback
        if (isCopy) {
          if (_this3.$route.query.f === "true") {
            _this3.hikeForm.isFeedbackEnabled = d.isFeedbackEnabled;
          } else {
            _this3.hikeForm.isFeedbackEnabled = true;
          }
        } else {
          _this3.hikeForm.isFeedbackEnabled = d.isFeedbackEnabled;
        }

        // LHVO-4824 Do not copy Post Program Feedback settings from original Hike
        if (isCopy) {
          _this3.hikeForm.isPostProgramFeedbackEnabled = false;
          _this3.hikeForm.postProgramFeedbackSurveyLandingPageUrl = null;
        } else {
          _this3.hikeForm.isPostProgramFeedbackEnabled = d.isPostProgramFeedbackEnabled;
          _this3.hikeForm.postProgramFeedbackSurveyLandingPageUrl = d.postProgramFeedbackSurveyLandingPageUrl;
        }
        // 

        _this3.hikeForm.ratingMethod = d.ratingMethod ? d.ratingMethod : "by_hike"; // if copy, ratingMethod finally override by backend

        // title
        if (isCopy) {
          _this3.hikeForm.title = _this3.$route.query.t === "true" ? d.title : "";
        } else {
          _this3.hikeForm.title = typeof d.title === "undefined" ? "" : d.title;
        }

        // internal title
        if (isCopy) {
          _this3.hikeForm.internal.title = _this3.$route.query.it === "true" ? d.internal.title : "";
        } else {
          _this3.hikeForm.internal.title = typeof d.title === "undefined" ? "" : d.internal.title;
        }

        // description
        if (isCopy) {
          _this3.hikeForm.description = _this3.$route.query.d === "true" ? d.description : "";
        } else {
          _this3.hikeForm.description = typeof d.description === "undefined" ? "" : d.description;
        }

        // rubric Id
        if (isCopy) {
          _this3.hikeForm.rubricId = "";
        } else {
          _this3.hikeForm.rubricId = d.rubricId;
        }

        // pid
        if (isCopy) {
          _this3.hikeForm.pid = "";
        } else {
          _this3.hikeForm.pid = d.pid;
        }

        // client Name
        if (isCopy) {
          _this3.hikeForm.internal.clientName = _this3.$route.query.cn === "true" ? d.internal.clientName : "";
        } else {
          _this3.hikeForm.internal.clientName = typeof d.internal === "undefined" ? "" : d.internal.clientName;
        }

        // resources
        if (isCopy) {
          _this3.hikeForm.resources = _this3.$route.query.r === "true" ? d.resources : [];
        } else {
          _this3.hikeForm.resources = typeof d.resources === "undefined" ? [] : d.resources;
        }

        // tags
        if (isCopy) {
          _this3.hikeForm.tags = _this3.$route.query.tag === "true" ? d.tags : [];
        } else {
          _this3.hikeForm.tags = typeof d.tags === "undefined" ? [] : d.tags;
        }

        // channel : webinar Info or Address
        if (isCopy) {
          _this3.hikeForm.category = _this3.$route.query.w === "true" ? d.category : "";
          _this3.hikeForm.channel = _this3.$route.query.w === "true" ? d.channel : "";
          _this3.hikeForm.webinarName = _this3.$route.query.w === "true" ? d.webinarName : "";
          _this3.hikeForm.webinarKey = _this3.$route.query.w === "true" ? d.webinarKey : "";
          _this3.hikeForm.webinarPasscode = _this3.$route.query.w === "true" ? d.webinarPasscode : "";
          _this3.hikeForm.zoomUrl = _this3.$route.query.w === "true" ? d.zoomUrl : "";
          if (_this3.$route.query.w === "true") {
            _this3.hikeForm.address.address1 = d.address.address1;
            _this3.hikeForm.address.address2 = d.address.address2;
            _this3.hikeForm.address.city = d.address.city;
            _this3.hikeForm.address.region = d.address.region;
            _this3.hikeForm.address.postalCode = d.address.postalCode;
            _this3.hikeForm.address.country = d.address.country;
          } else {
            _this3.hikeForm.address = {
              address1: "",
              address2: "",
              city: "",
              region: "",
              postalCode: "",
              country: ""
            };
          }
        } else {
          _this3.hikeForm.category = typeof d.category === "undefined" ? "" : d.category;
          _this3.hikeForm.channel = typeof d.channel === "undefined" ? "" : d.channel;
          _this3.hikeForm.webinarName = typeof d.webinarName === "undefined" ? "" : d.webinarName;
          _this3.hikeForm.webinarKey = typeof d.webinarKey === "undefined" ? "" : d.webinarKey;
          _this3.hikeForm.webinarPasscode = typeof d.webinarPasscode === "undefined" ? "" : d.webinarPasscode;
          _this3.hikeForm.zoomUrl = typeof d.zoomUrl === "undefined" ? "" : d.zoomUrl;
          _this3.hikeForm.address.address1 = typeof d.address.address1 === "undefined" ? "" : d.address.address1;
          _this3.hikeForm.address.address2 = typeof d.address.address2 === "undefined" ? "" : d.address.address2;
          _this3.hikeForm.address.city = typeof d.address.city === "undefined" ? "" : d.address.city;
          _this3.hikeForm.address.region = typeof d.address.region === "undefined" ? "" : d.address.region;
          _this3.hikeForm.address.postalCode = typeof d.address.postalCode === "undefined" ? "" : d.address.postalCode;
          _this3.hikeForm.address.country = typeof d.address.country === "undefined" ? "" : d.address.country;
        }

        // skillCompassDimension --> always copy from the source's hike. If cannot found the value in source, then set to 'auto'
        _this3.hikeForm.skillCompassDimensions = typeof d.skillCompassDimensions === "undefined" ? "auto" : d.skillCompassDimensions;

        // report
        if (isCopy) {
          if (_this3.$route.query.report === "true") {
            console.log("Dump report setting", d.report);
            _this3.hikeForm.report = typeof d.report === "undefined" ? {} : d.report;
          } else {
            _this3.hikeForm.report = {}; // No need to copy. just empty.
          }
        } else {
          console.log("Dump report setting", d.report);
          _this3.hikeForm.report = typeof d.report === "undefined" ? {} : d.report; // Load old
        }

        // remark
        _this3.hikeForm.internal.remark = isCopy ? "" : typeof d.internal === "undefined" ? "" : d.internal.remark;

        // feedback url
        _this3.hikeForm.feedbackUrl = isCopy ? "" : typeof d.feedbackUrl === "undefined" ? "" : d.feedbackUrl;

        // orientation Url
        _this3.hikeForm.orientationUrl = isCopy ? "" : typeof d.orientationUrl === "undefined" ? "" : d.orientationUrl;

        // trail Guide Url
        _this3.hikeForm.trailGuideUrl = isCopy ? "" : typeof d.trailGuideUrl === "undefined" ? "" : d.trailGuideUrl;

        // loop Schedule View Url
        _this3.hikeForm.loopScheduleViewUrl = isCopy ? "" : typeof d.loopScheduleViewUrl === "undefined" ? "" : d.loopScheduleViewUrl;

        // opportunityNumber
        _this3.hikeForm.internal.opportunityNumber = isCopy ? "" : typeof d.internal === "undefined" ? "" : d.internal.opportunityNumber;

        // metadata
        if (isCopy) {
          _this3.hikeForm.metadata = {
            tenant: ""
          };
        } else {
          _this3.hikeForm.metadata = typeof d.metadata === "undefined" ? {
            tenant: ""
          } : d.metadata;
        }

        // estimated Participant Count
        _this3.hikeForm.estimatedParticipantCount = isCopy ? 0 : typeof d.estimatedParticipantCount === "undefined" ? 0 : d.estimatedParticipantCount;

        // publish
        _this3.hikeForm.publish = isCopy ? "" : typeof d.publish === "undefined" ? "" : d.publish;

        // start date and end date
        if (isCopy) {
          if (_this3.$route.query.e === "true") {
            _this3.hikeForm.start.utc = typeof d.start.utc === "undefined" ? "" : d.start.utc;
            _this3.hikeForm.start.local = typeof d.start.local === "undefined" ? "" : d.start.local;
            _this3.hikeForm.start.timezone = typeof d.start.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.start.timezone;
            _this3.hikeForm.end.utc = typeof d.end.utc === "undefined" ? "" : d.end.utc; // d.end.utc.toISOString()
            _this3.hikeForm.end.local = typeof d.start.local === "undefined" ? "" : d.end.local;
            _this3.hikeForm.end.timezone = typeof d.end.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.end.timezone;
          } else {
            _this3.hikeForm.start = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
            _this3.hikeForm.end = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          }
        } else {
          // start date
          if (typeof d.start === "undefined") {
            _this3.hikeForm.start = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          } else {
            _this3.hikeForm.start.utc = typeof d.start.utc === "undefined" ? "" : d.start.utc;
            _this3.hikeForm.start.local = typeof d.start.local === "undefined" ? "" : d.start.local; // moment(d.start.local).tz(moment.tz.guess()).toString()
            _this3.hikeForm.start.timezone = typeof d.start.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.start.timezone;
          }

          // end date
          if (typeof d.end === "undefined") {
            _this3.hikeForm.end = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          } else {
            _this3.hikeForm.end.utc = typeof d.end.utc === "undefined" ? "" : d.end.utc; // d.end.utc.toISOString()
            _this3.hikeForm.end.local = typeof d.end.local === "undefined" ? "" : d.end.local; // moment(d.start.end).tz(moment.tz.guess()).toString() // d.end.local // d.end.utc.toISOString()
            _this3.hikeForm.end.timezone = typeof d.end.timezone === "undefined" ? _momentTimezone.default.tz.guess() : d.end.timezone;
          }
        }

        // Hike Stage
        if (isCopy) {
          if (_this3.$route.query.s === "true") {
            // copy stages
            var stages = _lodash.default.cloneDeep(d.stages);
            for (var i = 0; i < stages.length; i++) {
              // remove stages id
              delete stages[i].id;
              if (_this3.$route.query.e === "true") {
                if (typeof stages[i].start === "undefined" || stages[i].start.utc === null) {
                  stages[i].start = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
                if (typeof stages[i].end === "undefined" || stages[i].end.utc === null) {
                  stages[i].end = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
                if (typeof stages[i].enableStart === "undefined" || stages[i].enableStart.utc === null) {
                  stages[i].enableStart = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
                if (typeof stages[i].enableEnd === "undefined" || stages[i].enableEnd.utc === null) {
                  stages[i].enableEnd = {
                    utc: "",
                    timezone: _momentTimezone.default.tz.guess(),
                    local: ""
                  };
                }
              } else {
                stages[i].start = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                stages[i].end = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                stages[i].enableStart = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                stages[i].enableEnd = {
                  utc: "",
                  timezone: _momentTimezone.default.tz.guess(),
                  local: ""
                };
                if (stages[i].taskSortDay) stages[i].taskSortDay = 0;
              }

              // reassign the replayResourceID / Title
              if (typeof stages[i].replayResource === "undefined" || stages[i].replayResource === null) {
                // console.log('Main-stage-replayResource-undefined')
                stages[i].replayResource = "";
                stages[i].replayResourceTitle = "";
              } else {
                var replayResource = stages[i].replayResource;
                // console.log('Main-stage-replayResource', replayResource)
                stages[i].replayResource = typeof replayResource.id === "undefined" || replayResource.id === null ? "" : replayResource.id;
                stages[i].replayResourceTitle = typeof replayResource.title === "undefined" || replayResource.title === null ? "" : replayResource.title;
              }
            }
            _this3.hikeForm.stages = stages;
          } else {
            _this3.hikeForm.stages = [];
          }
        } else {
          // fill stages info (edit)
          // Reformat the replayResources
          for (var i = 0; i < d.stages.length; i++) {
            if (typeof d.stages[i].report === "undefined") {
              d.stages[i].report = _lodash.default.cloneDeep(_lifehikesInitData.defaultReport);
            }
            if (typeof d.stages[i].start === "undefined" || d.stages[i].start.utc === null) {
              d.stages[i].start = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].end === "undefined" || d.stages[i].end.utc === null) {
              d.stages[i].end = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].enableStart === "undefined" || d.stages[i].enableStart.utc === null) {
              d.stages[i].enableStart = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].enableEnd === "undefined" || d.stages[i].enableEnd.utc === null) {
              d.stages[i].enableEnd = {
                utc: "",
                timezone: _momentTimezone.default.tz.guess(),
                local: ""
              };
            }
            if (typeof d.stages[i].replayResource === "undefined" || d.stages[i].replayResource === null) {
              // console.log('Main-stage-replayResource-undefined')
              d.stages[i].replayResource = "";
              d.stages[i].replayResourceTitle = "";
            } else {
              var replayResource = d.stages[i].replayResource;
              // console.log('Main-stage-replayResource', replayResource)
              d.stages[i].replayResource = typeof replayResource.id === "undefined" || replayResource.id === null ? "" : replayResource.id;
              d.stages[i].replayResourceTitle = typeof replayResource.title === "undefined" || replayResource.title === null ? "" : replayResource.title;
            }
          }
          _this3.hikeForm.stages = d.stages;
        }
        if (isCopy) {
          _this3.hikeForm.staff = [];
          // this.reportRecipients = []
          // this.teams = []
        } else {
          _this3.hikeForm.staff = d.staff;
          var clientPocList = _this3.hikeForm.staff.filter(function (row) {
            return row.role === 'client-poc';
          });
          console.info('d.staff:');
          console.info(d.staff);
          console.info('clientPocList:');
          console.info(clientPocList);
          _this3.oldClientPocList = _lodash.default.cloneDeep(clientPocList);
          // this.getTeam(token, d.id)
          // this.reportRecipients = []
          // this.getReportRecipients(token, d.id)
        }

        // this.flagRemindSave = (this.hikeForm.stages[0].taskSortDay)? false : true

        // hike category is 'manager'
        if (d.survey) {
          // handle old hike data that without summitStart & summitEnd
          if (!d.survey.summitStart || !d.survey.summitEnd) {
            d.survey.summitStart = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
            d.survey.summitEnd = {
              utc: "",
              timezone: _momentTimezone.default.tz.guess(),
              local: ""
            };
          }

          // handle old hike data that without reminderSetting
          if (!d.survey.reminderSetting) {
            d.survey.reminderSetting = {
              benchmark: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              },
              summit: {
                isWeeklyNotify: false,
                notifyWeekday: [],
                isLastNotify: false,
                lastNotifyBeforeEffectiveEnd: 1
              }
            };
          }
          _this3.$set(_this3.hikeForm, 'survey', d.survey);
        }
        //Email Settings
        if (isCopy) {
          if (_this3.$route.query.es === "true") {
            _this3.hikeForm.automatedEmail = d.automatedEmail;
            _this3.hikeForm.emailRuleSet = d.emailRuleSet;
          } else {
            _this3.hikeForm.automatedEmail = [];
            _this3.hikeForm.emailRuleSet = _lhJsEmailContentLib.ruleSetNames.HIKE_EMAIL_RULE_SET_NO_EMAIL;
          }
        } else {
          _this3.hikeForm.automatedEmail = d.automatedEmail;
          _this3.hikeForm.emailRuleSet = d.emailRuleSet;
        }
        // To Solve internal title lagging issue, use other variable name to replace.
        _this3.hikeForm.tempInternalTitle = _this3.hikeForm.internal.title + "";
        //Clear it when category='no-rating'
        _this3.hikeForm.category = d.category === "no-rating" ? "" : d.category;
        //  createdAt and updatedAt
        if (isCopy) {
          _this3.hikeForm.createdAt = "";
          _this3.hikeForm.updatedAt = "";
        } else {
          _this3.hikeForm.createdAt = d.createdAt;
          _this3.hikeForm.updatedAt = d.updatedAt;
        }
        if (!isCopy) {
          var rlToken = (0, _cookie.getCookie)("ACCESS_TOKEN");
          _this3.relatedLoopsLoading = true;
          (0, _hike.hikeRelatedLoops)(rlToken, d.id).then(function (rlResponse) {
            _this3.relatedLoops = rlResponse.data.rows || [];
          }).catch(function (rlErr) {
            (0, _log.showDebugLog)("hike-hikeRelatedLoops-error", rlErr);
          }).finally(function () {
            _this3.relatedLoopsLoading = false;
          });
        }
        _this3.fullscreenloading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)("hike-getHikeById-error", error);
        _this3.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, "error");
      });
    },
    handleClick: function handleClick() {
      // do something later
      // auto save when change tab
    },
    updateReport: function updateReport(info) {
      this.hikeForm.report = info;
    },
    updateSkillCompassDimensions: function updateSkillCompassDimensions(info) {
      this.hikeForm.skillCompassDimensions = info + "";
    },
    updateParentStaff: function updateParentStaff(staff) {
      this.hikeForm.staff = staff;
      (0, _log.showDebugLog)("Update hikeForm-staff", this.hikeForm);
    },
    updateParentResource: function updateParentResource(res) {
      (0, _log.showDebugLog)("Parent hike-Resource", res);
      this.hikeForm.resources = res;
    },
    updateParentStage: function updateParentStage(res) {
      (0, _log.showDebugLog)("Parent hike-Stage", res);
      this.hikeForm.stages = res;
    },
    updateParentGenInfo: function updateParentGenInfo(info) {},
    checkArrayLength: function checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    },
    updateSurvey: function updateSurvey(survey) {
      this.hikeForm.survey = survey;
    },
    checkMandateFields: function checkMandateFields() {
      // console.log("form", this.hikeForm.staff)
      // var producer = _.find(this.hikeForm.staff, function(s) {
      //   return s.role === "producer";
      // });
      // // console.log("producer", producer)
      // // console.log("string length", _.trim(this.hikeForm.internal.opportunityNumber).length)
      // if (
      //   typeof producer === "undefined" ||
      //   _.trim(this.hikeForm.internal.opportunityNumber).length == 0
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }

      // LHVO-5020 - Save as Publish enabled only if “SF Opportunity number” is filled
      return _lodash.default.trim(this.hikeForm.internal.opportunityNumber).length == 0 ? true : false;
    },
    updateParentEmailRuleSet: function updateParentEmailRuleSet(info, type) {
      (0, _log.showDebugLog)("Parent EmailRuleSet", info);
      (0, _log.showDebugLog)("Parent EmailRuleSet", type);
      if (type === "ruleSet") {
        this.hikeForm.emailRuleSet = info;
      } else {
        this.hikeForm.automatedEmail = info;
      }
    }
  }
};